import { useEffect, useState } from 'react'
import { X } from 'react-feather'
import { isImageUploadFile, isVideoUploadFile } from '../../../../../api/progressiveUploadService'
import { SvgIcon } from '../../../../../shared/icons'
import { FilePreviewProps } from '../../../../../types/components/chat'
import { formatFileSize, getFileIconId } from '../../../../../utils/custom-functions/useFilePreview'

const FilePreview = ({ file, onRemove }: FilePreviewProps) => {
  const [preview, setPreview] = useState<string | null>(null)
  const isVideo = isVideoUploadFile(file)
  const isAviFile = file.name.toLowerCase().endsWith('.avi')

  useEffect(() => {
    let objectUrl: string | null = null
    let isCancelled = false

    setPreview(null)

    if (isImageUploadFile(file)) {
      const reader = new FileReader()
      reader.onloadend = () => {
        if (!isCancelled) {
          setPreview(reader.result as string)
        }
      }
      reader.readAsDataURL(file)
    } else if (isVideoUploadFile(file) && !isAviFile) {
      objectUrl = URL.createObjectURL(file)
      setPreview(objectUrl)
    }

    return () => {
      isCancelled = true
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [file, isAviFile])

  return (
    <div className="file-preview-item d-flex align-items-center gap-2 p-2 border rounded bg-light position-relative">
      {preview && isVideo ? (
        <video
          src={preview}
          className="rounded"
          muted
          preload="metadata"
          style={{ width: 72, height: 56, objectFit: 'cover' }}
        />
      ) : preview ? (
        <img src={preview} alt={file.name} className="rounded" style={{ width: 72, height: 56, objectFit: 'cover' }} />
      ) : (
        <div
          className="file-preview-item-content d-flex align-items-center justify-content-center bg-secondary rounded"
          style={{ width: 72, height: 56, flex: '0 0 72px' }}
        >
          <SvgIcon iconId={getFileIconId(file)} />
          {isAviFile && <span className="ms-1 small text-white">AVI</span>}
        </div>
      )}

      <div className="flex-grow-1 text-truncate">
        <div className="text-truncate small fw-medium" title={file.name}>
          {file.name}
        </div>
        <div className="text-muted">{formatFileSize(file.size)}</div>
      </div>

      <button onClick={onRemove} className="btn btn-sm btn-link text-danger p-0 border-0 bg-transparent" type="button">
        <X size={18} />
      </button>
    </div>
  )
}

export default FilePreview
